import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
}), 'DragHandleOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DragHandleOutlined.js
// module id = 3269
// module chunks = 2